(() => {
  const initRail = (scope) => {
    const rail = scope.querySelector('[data-pp-rail]');
    if (!rail || rail.dataset.ppReady) return;
    rail.dataset.ppReady = 'true';
    const isHero = scope.matches('[data-pp-hero]');
    const move = (direction) => rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: 'smooth' });

    if (isHero) {
      const dots = [...scope.querySelectorAll('[data-pp-dot]')];
      const slides = [...rail.querySelectorAll('.pp-hero__slide')];
      if (slides.length < 2) return;

      const firstClone = slides[0].cloneNode(true);
      const lastClone = slides[slides.length - 1].cloneNode(true);
      const deferCloneMedia = (clone) => {
        clone.querySelectorAll('source[srcset]').forEach((source) => {
          source.dataset.ppSrcset = source.srcset;
          source.removeAttribute('srcset');
        });
        clone.querySelectorAll('img').forEach((image) => {
          if (image.srcset) image.dataset.ppSrcset = image.srcset;
          if (image.src) image.dataset.ppSrc = image.src;
          image.removeAttribute('srcset');
          image.removeAttribute('src');
          image.loading = 'lazy';
          image.fetchPriority = 'low';
        });
      };
      const hydrateMedia = (slide) => {
        if (!slide || slide.dataset.ppMediaReady) return;
        slide.dataset.ppMediaReady = 'true';
        slide.querySelectorAll('source[data-pp-srcset]').forEach((source) => { source.srcset = source.dataset.ppSrcset; });
        slide.querySelectorAll('img[data-pp-src]').forEach((image) => {
          if (image.dataset.ppSrcset) image.srcset = image.dataset.ppSrcset;
          image.src = image.dataset.ppSrc;
        });
      };
      [firstClone, lastClone].forEach((clone) => {
        clone.dataset.ppClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('data-shopify-editor-block');
        deferCloneMedia(clone);
      });
      rail.prepend(lastClone);
      rail.append(firstClone);

      const slideWidth = () => rail.clientWidth;
      const physicalIndex = () => Math.round(rail.scrollLeft / slideWidth());
      const logicalIndex = () => {
        const index = physicalIndex();
        if (index === 0) return slides.length - 1;
        if (index === slides.length + 1) return 0;
        return Math.max(0, Math.min(slides.length - 1, index - 1));
      };
      const setActiveDot = () => {
        const activeIndex = logicalIndex();
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeIndex)));
      };
      const settleLoop = () => {
        const index = physicalIndex();
        if (index === 0) rail.scrollTo({ left: slides.length * slideWidth(), behavior: 'auto' });
        if (index === slides.length + 1) rail.scrollTo({ left: slideWidth(), behavior: 'auto' });
        setActiveDot();
      };
      let settleTimer;
      const handleScroll = () => {
        setActiveDot();
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settleLoop, 700);
      };
      let slideAnimation;
      const goToPhysicalSlide = (index) => {
        if (index === 0) hydrateMedia(lastClone);
        else if (index === slides.length + 1) hydrateMedia(firstClone);
        else hydrateMedia(slides[index - 1]);
        window.cancelAnimationFrame(slideAnimation);
        const start = rail.scrollLeft;
        const target = index * slideWidth();
        const distance = target - start;
        const duration = 650;
        const startedAt = performance.now();
        const animate = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 4);
          rail.scrollLeft = start + distance * easedProgress;
          if (progress < 1) slideAnimation = window.requestAnimationFrame(animate);
        };
        slideAnimation = window.requestAnimationFrame(animate);
      };

      let autoplayTimer;
      let autoplayArmed = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayArmed || reducedMotion.matches) return;
        autoplayTimer = window.setInterval(() => {
          if (!document.hidden) goToPhysicalSlide(physicalIndex() + 1);
        }, 5000);
      };
      const restartAutoplay = () => {
        autoplayArmed = true;
        stopAutoplay();
        startAutoplay();
      };
      const armAutoplay = () => {
        autoplayArmed = true;
        startAutoplay();
      };

      scope.querySelectorAll('[data-pp-prev]').forEach((button) => button.addEventListener('click', () => {
        goToPhysicalSlide(physicalIndex() - 1);
        restartAutoplay();
      }));
      scope.querySelectorAll('[data-pp-next]').forEach((button) => button.addEventListener('click', () => {
        goToPhysicalSlide(physicalIndex() + 1);
        restartAutoplay();
      }));

      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        goToPhysicalSlide(index + 1);
        restartAutoplay();
      }));
      rail.addEventListener('scroll', handleScroll, { passive: true });
      rail.addEventListener('pointerdown', () => slides.forEach(hydrateMedia), { once: true, passive: true });
      rail.addEventListener('wheel', () => slides.forEach(hydrateMedia), { once: true, passive: true });
      scope.addEventListener('mouseenter', stopAutoplay);
      scope.addEventListener('mouseleave', startAutoplay);
      scope.addEventListener('focusin', stopAutoplay);
      scope.addEventListener('focusout', startAutoplay);
      scope.addEventListener('touchstart', stopAutoplay, { passive: true });
      scope.addEventListener('touchend', armAutoplay, { passive: true });
      document.addEventListener('visibilitychange', startAutoplay);
      window.addEventListener('pointerdown', armAutoplay, { once: true, passive: true });
      window.addEventListener('keydown', armAutoplay, { once: true });
      window.addEventListener('resize', () => rail.scrollTo({ left: (logicalIndex() + 1) * slideWidth(), behavior: 'auto' }), { passive: true });
      rail.scrollTo({ left: slideWidth(), behavior: 'auto' });
      setActiveDot();
    } else {
      scope.querySelectorAll('[data-pp-prev]').forEach((button) => button.addEventListener('click', () => move(-1)));
      scope.querySelectorAll('[data-pp-next]').forEach((button) => button.addEventListener('click', () => move(1)));
    }
  };
  const initTestimonials = (scope) => scope.querySelectorAll('[data-pp-testimonials]').forEach((testimonials) => {
    if (testimonials.dataset.ppReady) return;

    const track = testimonials.querySelector('[data-pp-testimonials-track]');
    const slides = track ? [...track.children] : [];
    if (!track || slides.length < 2) return;

    testimonials.dataset.ppReady = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    let activeIndex = 0;
    let autoplayTimer;

    const render = () => {
      track.style.transform = mobile.matches ? `translate3d(-${activeIndex * 100}%, 0, 0)` : '';
      slides.forEach((slide, index) => {
        if (mobile.matches) slide.setAttribute('aria-hidden', String(index !== activeIndex));
        else slide.removeAttribute('aria-hidden');
      });
    };

    const stopAutoplay = () => window.clearInterval(autoplayTimer);
    const startAutoplay = () => {
      stopAutoplay();
      if (!mobile.matches || document.hidden) return;
      autoplayTimer = window.setInterval(() => {
        activeIndex = (activeIndex + 1) % slides.length;
        render();
      }, 5000);
    };

    const handleViewportChange = () => {
      if (!mobile.matches) activeIndex = 0;
      render();
      startAutoplay();
    };

    mobile.addEventListener('change', handleViewportChange);
    document.addEventListener('visibilitychange', startAutoplay);
    render();
    startAutoplay();
  });
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pp-hero], [data-pp-product-rail]').forEach(initRail);
    initTestimonials(scope);
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
